import React from 'react';
import { Tooltip, Typography } from '@mui/material';

function TextWithCharacterLimit({ defaultValue = '-', value, limit, tooltipProps = {}, ...rest }) {
  const valExceedingLimit = value?.length > limit;
  const slicedText = value?.slice(0, limit) + '...';

  return valExceedingLimit ? (
    <Tooltip placement="bottom" title={value} {...tooltipProps}>
      <Typography variant="body1" noWrap={true} {...rest}>
        {slicedText}
      </Typography>
    </Tooltip>
  ) : (
    <Typography variant="body1" noWrap={true} {...rest}>
      {value ?? defaultValue}
    </Typography>
  );
}

export default TextWithCharacterLimit;
